/**
 * Filter Keys Configuration
 * 탭별 필터 키 설정 (탭 닫을 때 필터 초기화용)
 */

export type FilterKeyMap = Record<string, string[]>;

/**
 * 페이지별 필터 스토리지 키 맵핑
 */
export const FILTER_KEYS: FilterKeyMap = {
    partner_deduction_history: ['partnerDeductionFilters'],
    fee_management: ['feeManagementFilters'],
    partner_settlement: ['partnerSettlementFilters'],
    settlement_history: ['partnerSettlementFilters'],
    rider_history_week: ['riderSettlementFilters'],
    rider_history_pre: ['riderPreSettlementFilters'],
    rider_deduction_history: ['riderDeductionFilters'],
    partner_status: ['supplierSelectionFilters'],
    partner_fee_to_head: ['feeManagementFilters'],
    rider_fee_to_supplier: ['supplierFeeFilters'],
    delivery_history: ['deliveryHistoryFilters'],
    delivery_history_detail: ['deliveryHistoryDetailFilters'],
    rider_status: ['riderStatusFilters'],
    transaction_history: ['headWithdrawFilters'],
    withdrawal_restriction: ['partnerAccountingFilters'],
    user_management: ['userManagementFilters'],
    rider_work_status: ['riderWorkStatusFilters'],
    virtual_account: ['virtualAccountFilters'],
};

/**
 * 탭 ID로 필터 키 조회
 * @param tabId 탭 ID
 * @returns 해당 탭의 필터 키 배열 또는 undefined
 */
export const getFilterKeysByTabId = (tabId: string): string[] | undefined => {
    return FILTER_KEYS[tabId];
};
